export const DEFAULT_WATCHLIST_NAME = 'Default Watchlist';
export const NEW_WATCHLIST_TEMP_ID = 'new';
